export default {
  nav: {
    home: 'Home',
    about: 'About Us',
    processing: 'Sheet Metal Processing',
    contact: 'Contact',
    imprint: 'Legal Notice',
    cta: 'Request a Quote',
  },
  footer: {
    tagline: 'Your high-performance partner for sheet-metal and metal processing. Precise, clean and reliable.',
    exploreLabel: 'Navigation',
    contactLabel: 'Contact',
    addressLine1: 'S+N Blech- und Metallverarbeitungs GmbH',
    addressLine2: 'Beierfelder Str. 22',
    addressLine3: '08315 Lauter-Bernsbach',
    phone: 'Phone',
    email: 'Email',
    legalLabel: 'Legal',
    rights: 'All rights reserved.',
  },
  home: {
    hero: {
      badge: 'Metal processing since 2001',
      titleLine1: 'Your partner for',
      titleHighlight: 'sheet-metal and metal processing',
      subtitle: 'We are your high-performance partner for all aspects of metal processing. On this site we would like to introduce our company and its services to you.',
      ctaPrimary: 'Explore our services',
      ctaSecondary: 'Get in touch',
      scrollHint: 'Learn more',
    },
    stats: [
      { value: '2001', label: 'Founded in Bernsbach' },
      { value: '20+', label: 'Years of experience' },
      { value: '100%', label: 'Reliability' },
      { value: '4', label: 'Core competencies' },
    ],
    intro: {
      eyebrow: 'Welcome',
      title: 'Precision in sheet metal and metal',
      p1: 'We are your high-performance partner for all aspects of metal processing. On this website we would like to introduce our company and its services to you.',
      p2: 'Our employees bring many years of professional experience in this industry. We work quickly and cleanly and are absolutely reliable.',
      p3: 'You can also conveniently request further information about our products by email.',
      point1: 'All common types of sheet metal',
      point2: 'Production to drawing and sample',
      point3: 'Short paths and direct contacts',
    },
    services: {
      eyebrow: 'Our services',
      title: 'Sheet-metal processing from a single source',
      subtitle: 'From the first enquiry to the finished part, we support your project with experience and care.',
      items: [
        { title: 'Cutting', desc: 'Precisely fitting cutting of all common sheet-metal types – to measure, drawing or sample.' },
        { title: 'Punching', desc: 'Precise punching technology for series parts and individual requirements.' },
        { title: 'Edging & Bending', desc: 'Clean edging and bending for dimensionally stable, accurate components.' },
        { title: 'Assembly work', desc: 'Complete assembly and pre-assembly work for your assemblies.' },
      ],
      cta: 'View all services',
    },
    why: {
      eyebrow: 'Why S+N',
      title: 'Experience you can see',
      subtitle: 'We work quickly and cleanly – and are absolutely reliable.',
      items: [
        { title: 'Many years of experience', desc: 'Rooted in the industry since 2001, with decades of hands-on experience in our team.' },
        { title: 'Absolutely reliable', desc: 'Fast, clean execution and binding deadlines – you can rely on that.' },
        { title: 'Broad material knowledge', desc: 'Whether stainless steel, steel or aluminium – we process all common sheet-metal types for you.' },
      ],
    },
    process: {
      eyebrow: 'How we work',
      title: 'Your part in four steps',
      subtitle: 'Clear, direct and without detours – from enquiry to delivery.',
      steps: [
        { title: 'Enquiry', desc: 'You send us your enquiry including drawing, sample or description.' },
        { title: 'Consultation', desc: 'We advise you on material, feasibility and the right production method.' },
        { title: 'Production', desc: 'Cutting, punching, edging and assembly – all from a single source.' },
        { title: 'Delivery', desc: 'Reliable deadlines and clean handover of your components.' },
      ],
    },
    gallery: {
      eyebrow: 'Insights',
      title: 'A look inside our production',
      subtitle: 'Machines, components and workpieces from our daily work.',
      cta: 'See more images',
    },
    cta: {
      title: 'Talk to us',
      subtitle: 'If you have any questions about our products, just get in touch! We are happy to advise you on your project.',
      primary: 'Send enquiry',
      secondary: 'info@sn-metall.de',
    },
  },
  about: {
    hero: {
      eyebrow: 'About us',
      title: 'A family business with a history',
      subtitle: 'Since 2001 we have stood for reliable sheet-metal and metal processing in Lauter-Bernsbach.',
    },
    story: {
      eyebrow: 'Our story',
      title: 'Founded in 2001, grown with experience',
      p1: 'Our company was founded in 2001 by S. Schneider and his partner as a GmbH in Bernsbach.',
      p2: 'In 2006 Mr Schneider became the sole shareholder of the company.',
      p3: 'Since 2015 the gradual handover to his daughter took place and Axel Friedrich became the new managing director.',
    },
    facts: {
      founded: 'Founded',
      management: 'Management',
      location: 'Location',
    },
    timeline: {
      eyebrow: 'Milestones',
      title: 'Our development',
      items: [
        { year: '2001', title: 'Founded in Bernsbach', desc: 'S. Schneider and his partner found S+N Blech- und Metallverarbeitungs GmbH.' },
        { year: '2006', title: 'Sole shareholder', desc: 'Mr Schneider takes over all shares and continues to run the company independently.' },
        { year: '2015', title: 'Generational change', desc: 'The gradual handover to his daughter begins – Axel Friedrich becomes the new managing director.' },
      ],
    },
    management: {
      eyebrow: 'Management',
      title: 'Your contact person',
      name: 'Axel Friedrich',
      role: 'Managing Director',
      quote: 'We work quickly and cleanly and are absolutely reliable – a promise we make on every order.',
    },
    values: {
      eyebrow: 'Our values',
      title: 'What you can rely on',
      items: [
        { title: 'Experience', desc: 'Many years of professional experience in metal processing on every project.' },
        { title: 'Reliability', desc: 'Binding commitments, clean work and punctual delivery.' },
        { title: 'Quality', desc: 'Precise processing and careful inspection of every component.' },
        { title: 'Partnership', desc: 'Personal advice and direct contacts for your request.' },
      ],
    },
  },
  processing: {
    hero: {
      eyebrow: 'Sheet metal processing',
      title: 'Cutting, punching, edging, assembly work',
      subtitle: 'We process all common sheet-metal types for you – precise, clean and on time.',
    },
    intro: {
      eyebrow: 'Our expertise',
      title: 'If you have any questions about our products, just get in touch!',
      p1: 'We process all common sheet-metal types for you – from one-off parts to series production.',
      p2: 'From cutting and punching through edging to assembly work, you get every step from a single source.',
    },
    capabilities: {
      eyebrow: 'Services in detail',
      title: 'Four core competencies',
      subtitle: 'Everything around sheet-metal processing – competent and from a single source.',
      items: [
        { title: 'Cutting', desc: 'Precisely fitting cutting of thin and thick sheets to measure, drawing or sample.' },
        { title: 'Punching', desc: 'Punching technology for series parts, hole patterns and individual requirements.' },
        { title: 'Edging & Bending', desc: 'Dimensionally stable edges and bends for accurate components.' },
        { title: 'Assembly work', desc: 'Assembly and pre-assembly of complete assemblies to your specifications.' },
      ],
    },
    materials: {
      eyebrow: 'Materials',
      title: 'All common sheet-metal types',
      subtitle: 'We process the common materials used in sheet-metal working for you.',
      items: ['Stainless steel', 'Steel', 'Aluminium', 'Thin sheet', 'Non-ferrous metals', 'Coated sheets'],
    },
    gallery: {
      eyebrow: 'References',
      title: 'Workpieces from our production',
      subtitle: 'A selection of components and work from our workshop.',
    },
  },
  contact: {
    hero: {
      eyebrow: 'Contact',
      title: 'Get in touch with us',
      subtitle: 'Let us advise you on our products and services. Our team will assist you with help and advice.',
    },
    info: {
      eyebrow: 'How to reach us',
      title: 'Your contacts in Lauter-Bernsbach',
      addressLabel: 'Address',
      addressValue: 'Beierfelder Str. 22, 08315 Lauter-Bernsbach',
      phoneLabel: 'Phone',
      emailLabel: 'Email',
      hoursLabel: 'Availability',
      hoursValue: 'Mon – Fri: 7:00 am – 4:00 pm',
    },
    form: {
      title: 'Send an enquiry',
      subtitle: 'Fill in the form – we will get back to you as soon as possible.',
      nameLabel: 'Name',
      namePlaceholder: 'Your name',
      emailLabel: 'Email',
      emailPlaceholder: 'your@email.com',
      phoneLabel: 'Phone',
      phonePlaceholder: 'Optional',
      subjectLabel: 'Subject',
      subjectOptions: ['Request a quote', 'Consultation', 'Other'],
      messageLabel: 'Message',
      messagePlaceholder: 'Briefly describe your request …',
      submit: 'Send enquiry',
      submitting: 'Sending …',
      success: 'Thank you! Your enquiry has been submitted. We will get back to you.',
      error: 'There was a problem sending your message. Please try again or write us an email directly.',
      required: 'Please fill in the required fields correctly.',
    },
  },
  imprint: {
    hero: {
      eyebrow: 'Legal',
      title: 'Imprint',
      subtitle: 'Information pursuant to § 5 TMG',
    },
    addressTitle: 'Address',
    contactTitle: 'Contact',
    representativeTitle: 'Represented by',
    registerTitle: 'Commercial register',
    vatTitle: 'VAT identification number',
    disclaimerTitle: 'Disclaimer',
    disclaimer:
      'The contents of these pages were created with the greatest care. However, we cannot accept any liability for the accuracy, completeness or topicality of the content. The operators of linked external pages are solely responsible for their content.',
  },
};